export default __webpack_public_path__ + "alberta-warning.7666f47d8bc706b859dd.svg";